import React from 'react';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';
import { usePortletTranslations } from 'js/components/system/Portlet';

export const Indicator = ({ count = 0, className = '' }) => (
    <span className={`${style.indicator} ${className}`}>
        {count}
    </span>
);

export const Toggle = ({ isOpen, appliedFiltersCount, onClick }) => {
    const t = usePortletTranslations();

    return (
        <Button view="secondary"
            variant="rounded"
            color="generic"
            size="medium"
            className={`${style.btn} ${style.toggle}`}
            onClick={onClick}>
            <Icon type="filter" className={style.icon} />
            {t(`${isOpen ? 'hideFilters' : 'showFilters'}`)}
            {appliedFiltersCount > 0 && !isOpen && <Indicator count={appliedFiltersCount} />}
        </Button>
    );
};

export default Toggle;
